var render = function render(){var _vm=this,_c=_vm._self._c;return _c('WrappedForm',{ref:"form",staticClass:"workExperience-editor",attrs:{"labelWidth":"150px","model":_vm.workExperienceData,"formLines":_vm.formLines},scopedSlots:_vm._u([{key:"salaryInfo",fn:function(){return [_c('span',[_vm._v(_vm._s(_vm.$t(`${_vm.i18nPrefix}.label.salaryInfo`)))])]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }